// Pure, DOM-light decision logic for the FF_SSE_UI_* kill switches — pulled out
// of main.js so it's importable in a test without dragging in the app bootstrap
// (AuthController.init() etc.), which main.js triggers as a side effect of import.
import { FEATURE_FLAGS, isEnabled } from '../../../../shared/featureFlags.js';

/** Whether the dark-mode feature (toggle button + persisted theme) is available at all. */
export function darkModeEnabled() {
  return isEnabled('FF_SSE_UI_DARK_MODE');
}

/**
 * The theme to apply at boot. Forces 'light' when the FF_SSE_UI_DARK_MODE kill
 * switch is off, regardless of a 'dark' value already sitting in localStorage
 * from before the flag was flipped off.
 */
export function resolveInitialTheme(enabled = darkModeEnabled()) {
  if (!enabled) return 'light';
  return localStorage.getItem(FEATURE_FLAGS.FF_SSE_LS_THEME) === 'dark' ? 'dark' : 'light';
}

/** Whether the FF_SSE_UI_ANIMATIONS kill switch means animations/transitions should be suppressed. */
export function animationsDisabled(enabled = isEnabled('FF_SSE_UI_ANIMATIONS')) {
  return !enabled;
}

/** Remove the <m5t-side-nav> "theme" footer button when dark mode is disabled,
 *  rather than leaving a dead button pointing at a no-op toggle. */
export function applyDarkModeButtonVisibility(nav, enabled = darkModeEnabled()) {
  if (!nav || enabled) return;
  nav.shadowRoot?.querySelector('.footer-action[data-action="theme"]')?.remove();
}
